module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-6.2b38260d.svg";